import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { supabase } from '../../lib/supabase';
import { Car as Cards, Package, Swords, LogOut, Settings } from 'lucide-react';

export default function Header() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.email === 'admin@baby-sittign.xyz';

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="text-2xl font-bold text-indigo-600">
                🎮 Battle Cards
              </Link>
            </div>
            {user && (
              <nav className="ml-6 flex space-x-4">
                <Link
                  to="/collection"
                  className="inline-flex items-center px-1 pt-1 text-gray-900 hover:text-indigo-600"
                >
                  <Cards className="h-5 w-5 mr-1" />
                  Collection
                </Link>
                {!isAdmin && (
                  <>
                    <Link
                      to="/booster"
                      className="inline-flex items-center px-1 pt-1 text-gray-900 hover:text-indigo-600"
                    >
                      <Package className="h-5 w-5 mr-1" />
                      Booster
                    </Link>
                    <Link
                      to="/combat"
                      className="inline-flex items-center px-1 pt-1 text-gray-900 hover:text-indigo-600"
                    >
                      <Swords className="h-5 w-5 mr-1" />
                      Combat
                    </Link>
                  </>
                )}
                {isAdmin && (
                  <Link
                    to="/admin"
                    className="inline-flex items-center px-1 pt-1 text-gray-900 hover:text-indigo-600"
                  >
                    <Settings className="h-5 w-5 mr-1" />
                    Administration
                  </Link>
                )}
              </nav>
            )}
          </div>
          {user && (
            <div className="flex items-center">
              <span className="text-sm text-gray-600 mr-4">
                {user.email}
              </span>
              <button
                onClick={handleLogout}
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <LogOut className="h-4 w-4 mr-1" />
                Déconnexion
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}